import React from "react";
import { IonToast } from "@ionic/react";

export interface Reward {
  message: string;
  icon?: string;
  color?: "success" | "primary" | "warning";
}

/** Petit toast de récompense (XP, série, niveau, badge). La gamification reste discrète. */
const RewardToast: React.FC<{ reward: Reward | null; onDismiss: () => void }> = ({ reward, onDismiss }) => (
  <IonToast
    isOpen={Boolean(reward)}
    message={reward ? `${reward.icon || "✨"} ${reward.message}` : ""}
    duration={2200}
    position="top"
    color={reward?.color || "success"}
    onDidDismiss={onDismiss}
  />
);

export default RewardToast;
